import React from 'react';
import {Link} from 'react-router-dom'

function LogoImage(props) {

    return <Link to={`${process.env.PUBLIC_URL}/`} className="custom-logo-link">
                <span className="screen-reader-text">D2D Universal</span>
                <img src={`${process.env.PUBLIC_URL}/assets/images/${props.logo}`} alt="" className="img-fluid" style={{'height':'80px'}} />
            </Link>;
}
export default LogoImage;